<template>
  <div class="bottom-bar">
    <div class="bottom-item" v-for="(item,index) in barItems" :key="item.icon + index" @click="clickBarItem(item.key)">
      <i :class="['iconfont', item.icon]"></i>
      <p>{{item.label}}</p>
    </div>
    
  </div>  
</template>

<script>
import editorMore from '@/views/cv-editor/editor-more'
export default {
  name:'bottombar',
  data(){
    return {
      barItems: [
        {label: '简历预览', icon: 'iconjianliyulan', key: 'yulan'},
        {label: '模块管理', icon: 'iconmokuaiguanli', key: 'guanli'},
        {label: '导师辅导', icon: 'icondaoshifudao1', key: 'fudao'},
        {label: '更多', icon: 'icongengduo1', key: 'gengduo'},
      ],
      resumeToken: this.$route.params.token
    }
  },
  components: {editorMore},
  methods: {
    refreshName() {},
    changeMoreState() {},
    changeCv() {},
    clickBarItem(key) {
      this.$emit('editorBottomClick', key)
    }
  }
}
</script>

<style scoped lang="scss">
 .bottom-bar{
   position: fixed;
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 45px;
   bottom: 32px;
   height: 76px;
   box-sizing: border-box;
   background: #5D5F6D;
   border-radius: 20px;
   width: 94%;
   left: 50%;
   transform: translateX(-50%);
   .bottom-item{
     white-space: nowrap;
     color: #fff;
     text-align: center;
     font-size: 12px;
     &>i{
      display: inline-block;
      font-size: 24px;
      margin-bottom: 8px;
     }
   }
 }
</style>
